import '@/App.css';
import '@/i18n'; // Initialize i18n
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import LandingPage from '@/pages/LandingPage';
import LoginPage from '@/pages/LoginPage';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import Profile from '@/pages/Profile';
import RankingLists from '@/pages/RankingLists';
import RankingDetail from '@/pages/RankingDetail';
import SendInvite from '@/pages/SendInvite';
import MatchScore from '@/pages/MatchScore';
import AdminDashboard from '@/pages/AdminDashboard';
import MyRankings from '@/pages/MyRankings';
import DatabaseViewer from '@/pages/DatabaseViewer';
import AllMatches from '@/pages/AllMatches';
import ClubLeaderboard from '@/pages/ClubLeaderboard';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import ProtectedRoute from '@/components/ProtectedRoute';
import OptionalAuthRoute from '@/components/OptionalAuthRoute';
import { useState, useEffect } from 'react';

function AppRouter() {
  const location = useLocation();
  
  // Check for session_id in URL fragment SYNCHRONOUSLY
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/my-rankings" element={<ProtectedRoute><MyRankings /></ProtectedRoute>} />
      <Route path="/ranking-lists" element={<OptionalAuthRoute><RankingLists /></OptionalAuthRoute>} />
      <Route path="/ranking-lists/:listId" element={<OptionalAuthRoute><RankingDetail /></OptionalAuthRoute>} />
      <Route path="/send-invite" element={<ProtectedRoute><SendInvite /></ProtectedRoute>} />
      <Route path="/matches/:matchId" element={<ProtectedRoute><MatchScore /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/database" element={<ProtectedRoute><DatabaseViewer /></ProtectedRoute>} />
      <Route path="/admin/all-matches" element={<ProtectedRoute><AllMatches /></ProtectedRoute>} />
      <Route path="/club-leaderboard" element={<ProtectedRoute><ClubLeaderboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;